import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlocksRoutingModule } from './blocks-routing.module';
import { SharedModule } from '../shared/shared/shared.module';
import { AppComponent } from './root/app.component';
import { HomeComponent } from './home/home/home.component';
import { MenuComponent } from './menu/menu.component';
import { TopNavBarComponent } from './top-nav-bar/top-nav-bar.component';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [AppComponent, HomeComponent, MenuComponent, TopNavBarComponent],
  imports: [
    SharedModule,
    BlocksRoutingModule,
    NgxSpinnerModule.forRoot({
      type: 'ball-scale-multiple',
    }),
  ],
  exports:[AppComponent]
})
export class BlocksModule { }
